import { render, staticRenderFns } from "./TIPO_PRE_CABECALHO.vue?vue&type=template&id=7a1c2620"
import script from "./TIPO_PRE_CABECALHO.vue?vue&type=script&lang=js"
export * from "./TIPO_PRE_CABECALHO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports